<template>
     <!-- 全屏容器 -->
     <div class="main">
       <v-scale-screen fullScreen width="4208" height="1296" :boxStyle="{ background: '#fff' }">
     <!-- <v-scale-screen fullScreen width="3710" height="1080" :boxStyle="{ background: '#fff' }"> -->
        <!-- <div id="index-box"> -->
        <dv-loading class="loading" v-if="loading">Loading...</dv-loading>
        <div class="main-body" :style="{ visibility: loading?'hidden':'visible' }">
        <!--   <dv-full-screen-container id="index-box"> -->

          <div class="top-header">
            <dv-decoration-8 :reverse="true" style="width:25%;height:60px;" />
            <dv-decoration-5 style="width:40%;height:60px;margin-top:40px" />
            <dv-decoration-8 :reverse="true" style="width:25%;height:60px;" />
            <div class="center-title">AEO大数据 <span style="font-size: 30px;"> AEO Big Data</span></div>
          </div>
          <div class="topBtn">
            <!-- <div class="search">
              <span class="active">2023</span>
              <span>2022</span>
              <span>2021</span>
            </div>
             -->

            <div class="full-screen" @click="toFullOrExit">
              <img :src="fullImg" alt="">
            </div>
          </div>
          <div class="index">
            <div class="left" style="display: flex;flex-direction: column;margin-bottom:10px">
              <div style="width: 100%;display: flex;min-height: 0px;flex:1">
                <LeftOne style="flex:1;" :customCode="statusCode" @setValue="valueFn"></LeftOne>
                <!-- <LeftTwo style="flex:1;margin:0 15px" ></LeftTwo>
                <LeftThree style="flex:1;" ></LeftThree> -->
              </div>

              <div style="width: 100%;height: 300px;margin-top:10px"></div>
              <!-- <Bottom style="width: 100%;height: 300px;margin-top:10px"></Bottom> -->
            </div>
            <div class="center">
                <div class="map" style="padding:0 20px">
                  <div class="returnBox" v-show="isreturn">
                    <div class="return" @click="rebackMap" >返回</div>
                    <span class="mapName">{{mapName}}地图</span>
                    <span></span>
                  </div>
                  <div id="map" style="height:100%;"></div>
                </div>
            </div>
            <div class="right" style="display: flex;">
              <RightOne style="flex:1"></RightOne>
              <RightTwo style="flex:2"></RightTwo>
            </div>
          </div>
          <!-- </dv-border-box-11> -->
        </div>
        <!-- </dv-full-screen-container> -->
     </v-scale-screen>
    </div>
</template>

<script>
  import cityExport from '../components/cityExport.js';
  import statusCity from '../components/annotatedCity.js';
  import * as echarts from 'echarts';
  import imgTest from "../../static/haiguan.png";
  import imgTest1 from "../../static/dizhi.gif";

  import RightOne from '../components/rightNew/rightOne.vue'
  import RightTwo from '../components/rightNew/rightTwo.vue'
  import LeftOne from '../components/leftNew/leftOne.vue'
  import LeftTwo from '../components/leftNew/leftTwo.vue'
  import LeftThree from '../components/leftNew/leftThree.vue'
  import Bottom from '../components/leftNew/bottom.vue'
  import common from '../components/api';
export default {
  name: 'index',
  components: {
      RightOne,
      RightTwo,
      LeftOne,
      LeftTwo,
      LeftThree,
      Bottom
  },
  data () {
    return {
      loading:true,
      fullImg:"../../static/quanping_o.png",
      isFull:false,
      isreturn: false, // 是否显示返回全国地图按钮
      mapChart: null, //地图对象
      mapOption: null,//地图属性
      mapName:"",
      dataList: [ //地图标记经纬度坐标和code码,可只要经纬度
        { name: "黄埔海关", value: [	113.709693, 23.163951]},
        { name: "江门海关", value: [113.081415, 22.579089]},
      ],
      seriesData:{},
      regions:{},
      statusCode:'',//当前选中的海关code

      countryCode: "" ,//国家编码
    }
  },
   mounted() {
     console.log(cityExport)
      setTimeout(()=>{
       this.getMap();
     },1000)
      this.dataInfo();



      this.$Bus.$on('getIAndETradeAmount', e => {
        console.log('**',e);
        this.mapName = e.originalProvinceName;
      })

    },
    methods: {
      valueFn(value) {
        this.countryCode = value;
      },
      
      dataInfo(){
        //进出口总值  左边第一行的三个值
        this.$axios.post(common.apihost+'/aeo/tradeData/getIAndETradeAmount',{
            customCode:this.statusCode,
        }).then(res =>{
           this.$Bus.$emit('getIAndETradeAmount', res.data.data)
        })

        //左边第二行的数据
        this.$axios.post(common.apihost+'/aeo/tradeData/getCountryTradeAmountRanking',{
            customCode:this.statusCode,
        }).then(res =>{
            this.$Bus.$emit('getCountryTradeAmountRanking', {data:res.data.data,unit:'亿'})
        })
        //左边第三行的数据
        this.$axios.post(common.apihost+'/aeo/tradeData/getCountryTradeAmountProportion',{
            customCode:this.statusCode,
        }).then(res =>{
            this.$Bus.$emit('getCountryTradeAmountProportion', res.data.data)
        })

        //右边企业数据
        this.$axios.post(common.apihost+'/aeo/tradeData/getCustomCompanyData',{
            customCode:this.statusCode,
        }).then(res =>{
          this.$Bus.$emit('getCustomCompanyData', res.data.data)
          this.loading = false;
        })

      },
        getMap() {
          if (!this.mapChart) {
            this.mapChart = this.$echarts.init(document.getElementById('map'));
          }
          let symbolImg = 'image://'+ imgTest
          this.mapOption = {
             grid: {
                    left: '3%', //默认10%
                    right: '34%', //默认10%
                    bottom: '1%', //默认60
                    containLabel: true
                    //grid区域是否包含坐标轴的刻度标签
                },
            tooltip: {// 提示浮窗样式
              show: true,
              trigger: "item",
              alwaysShowContent: false,
              backgroundColor: "#121837",
              borderColor: "#7881B3",
              hideDelay: 100,
              triggerOn: "mousemove",
              enterable: true,
              textStyle: {
                color: "#DADADA",
                fontSize: "12",
                width: 20,
                height: 30,
                overflow: "break",
              },
              showDelay: 100
            },
            map: 'china',
            roam: true,//是否启缩放和平移
            scaleLimit: {
              min: 1,
              max: 5
            },
            label: {
              normal: {
                show: true,
                fontSize: '10',
                color: '#fff'
              }
            },
            geo: {
              map: "china",
              //roam: true,// 可以通过鼠标滚轮放大缩小地图
              zoom:'1.2',
              show: true,
              label: {
                normal: {
                  show: false,//是否显示地图省份名字
                  textStyle: {
                    color: "#fff",//地图名字颜色
                  },
                },
                emphasis: { // 鼠标放上去地图文字的样式
                  textStyle: {
                    color: "#eee",
                  },
                },
              },
              itemStyle: { // 地图区域的样式设置
                normal: {
                  areaColor: 'rgba(49, 167, 225, .2)', //rgba设置透明度0
                  borderColor: "#39A1FB",
                  borderWidth: 1,
                },
                emphasis: {  // 鼠标放上去地图高亮的样式
                  areaColor: "rgba(49, 167, 225, .7)",
                  borderWidth: 0,
                },
              },
            },
            series: [
              {
                type: "map",
                map: "china",
                name: '港口信息',
                coordinateSystem: 'geo',

                type: 'scatter',
                symbol: symbolImg, //自定义的展示图标
                symbolSize:20,
                roam: false,
                label: {
                    formatter: (params) => {
                      return params.data.name;
                    },
                    color: '#fff',
                    backgroundColor: '#E5775B',
                    lineHeight: 18,
                    fontSize:17,
                     distance: 5,
                    avoidLabelOverlap: true,
                    padding: 5,
                    show: true,
                    position: 'outside',


                },
                data: []
              }

            ],
          };
          //将中国地图 分为市为单位
          let chinaData = {
            type:"FeatureCollection",
            features:[]
          }
          let newData  = cityExport.china.features.filter(function(item) {
            return (item.properties.name != "广东") && (item.properties.name != "内蒙古") && (item.properties.name != "山东") && (item.properties.name != "浙江") && (item.properties.name != "福建") && (item.properties.name != "辽宁")
          });
          for(let i =0;i<cityExport.cityList.length;i++){
            if(cityExport.cityList[i].name.indexOf('广东')!='-1' || cityExport.cityList[i].name.indexOf('内蒙古')!='-1' || cityExport.cityList[i].name.indexOf('山东')!='-1' || cityExport.cityList[i].name.indexOf('浙江')!='-1'|| cityExport.cityList[i].name.indexOf('福建')!='-1'|| cityExport.cityList[i].name.indexOf('辽宁')!='-1'){

              if(cityExport.cityList[i].name.indexOf('广东')!='-1'){
                console.log(cityExport.cityList[i].data.features,'888');
                let arr  = cityExport.cityList[i].data.features.filter(function(item) {//把广州市删除替换成区的方式显示
                     return item.properties.name != "广州市"
                 });
                 let arr1 = arr.concat(cityExport.guangzhou.features)
                 newData = newData.concat(arr1);
              }else{
                 newData = newData.concat(cityExport.cityList[i].data.features);
              }
            }
          }
          chinaData.features = newData;
          //将中国地图 分为市为单位

          // 地图注册，第一个参数的名字必须和option.geo.map一致
          this.$echarts.registerMap('china', chinaData);
          console.log(statusCity.statusCity,'活跃的城市');
          console.log(cityExport.cityList,'市');
          console.log(cityExport.china,'中国');
          let seriesData = [];
          let regions = [];
          for(let key in statusCity.statusCity){
            seriesData = seriesData.concat(statusCity.statusCity[key].seriesData);
            for(let i=0;i<statusCity.statusCity[key].regions.length;i++){
              regions.push({
                name: statusCity.statusCity[key].regions[i].name,
                label: { color: statusCity.statusCity[key].regions[i].fontColor },
                itemStyle: { areaColor: statusCity.statusCity[key].regions[i].BgColor },
                parentName:key,
                code:statusCity.statusCity[key].regions[i].code
              })
            }
          }
          console.log(seriesData,'seriesData')
          console.log(regions,'regions')

          this.mapOption.geo.regions = regions;//设置显示的海关
          this.regions = regions;
          this.mapOption.series[0].data = seriesData;//中国设置市级单位显示
          this.seriesData = seriesData;
          this.mapChart.setOption(this.mapOption);


          //地图点位点击事件
          this.mapChart.on('click', params => {
            console.log(params);
            this.statusCode = (params.data && params.data.code)  || params.region.code;
            console.log(this.statusCode);
            this.dataInfo();
            let provinceName = (params.data && params.data.parentName)  || params.region.parentName || params.name;
            // this.mapName = provinceName;
            console.log(provinceName)
            // 判断点击的省份是否有标记点 有则只显示该省的标记 否则会将其他省份的坐标点一起显示
            cityExport.cityList.map((value,index) => {
              if (value.name.indexOf(provinceName) !== -1) {
                this.mapChart.clear();
                let data = {};
                if(provinceName=='广东'){
                  data = {
                    features:[],
                    type: "FeatureCollection"
                  };
                  let newData  = value.data.features.filter(function(item) {//把广州市删除替换成区的方式显示
                       return item.properties.name != "广州市"
                   });
                  data.features = newData.concat(cityExport.guangzhou.features);
                  this.mapOption.series[0].data = [
                    { parentName:'广东',name: "黄埔海关",code:'52', value: [	113.545611,23.383707]},
                    { parentName:'广东',name: "江门海关",code:'68', value: [113.081415, 22.579089]},
                    { parentName:'广东',name: "汕头海关",code:'60', value: [116.747794,23.383024]},
                    { parentName:'广东',name: "湛江海关",code:'67', value: [110.357229,21.206645]},
                    { parentName:'广东',name: "深圳海关",code:'53', value: [114.072841,22.546755]},
                    { parentName:'广东',name: "拱北海关",code:'57', value: [113.563842,22.223781]},
                    { parentName:'广东',name: "广州海关",code:'51', value: [113.326979,23.126103]},
                  ];
                  this.mapOption.geo.regions = [{
                    name: '黄埔区',
                    code:'52',
                     parentName:'广东',
                    label: { color: '#000' },
                    itemStyle: { areaColor: '#A2D6F5' }
                  },{
                    name: '增城区',
                    code:'52',
                     parentName:'广东',
                    label: { color: '#000' },
                    itemStyle: { areaColor: '#A2D6F5' }
                  },{
                    name: '东莞市',
                    code:'52',
                     parentName:'广东',
                    label: { color: '#000' },
                    itemStyle: { areaColor: '#A2D6F5' }
                  },{
                    name: '江门市',
                    code:'68',
                     parentName:'广东',
                    label: { color: '#000' },
                    itemStyle: { areaColor: '#63AEEB' }
                  },{
                    name: '阳江市',
                    code:'68',
                     parentName:'广东',
                    label: { color: '#000' },
                    itemStyle: { areaColor: '#63AEEB' }
                  },{
                    name: '汕头市',
                    code:'60',
                     parentName:'广东',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#0074FF' }
                  },{
                    name: '潮州市',
                    code:'60',
                     parentName:'广东',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#0074FF' }
                  },{
                    name: '普宁市',
                    code:'60',
                     parentName:'广东',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#0074FF' }
                  },{
                    name: '揭阳市',
                    code:'60',
                     parentName:'广东',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#0074FF' }
                  },{
                    name: '汕尾市',
                    code:'60',
                     parentName:'广东',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#0074FF' }
                  },{
                    name: '梅州市',
                    code:'60',
                     parentName:'广东',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#0074FF' }
                  },{
                    name: '湛江市',
                    code:'67',
                    parentName:'广东',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#0290A9' }
                  },{
                    name: '茂名市',
                    code:'67',
                     parentName:'广东',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#0290A9' }
                  },
                  {
                    name: '深圳市',
                    label: { color: '#fff' },
                    code:'53',
                     parentName:'广东',
                    itemStyle: { areaColor: '#38B03F' }
                  },
                  {
                    name: '惠州市',
                    code:'53',
                     parentName:'广东',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#38B03F' }
                  },

                  {
                    name: '珠海市',
                    code:'57',
                     parentName:'广东',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#B4A2FF' }
                  },
                  {
                    name: '中山市',
                    code:'57',
                     parentName:'广东',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#B4A2FF' }
                  },

                  {
                    name: '佛山市',
                    code:'51',
                     parentName:'广东',
                    label: { color: '#000' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  {
                    name: '肇庆市',
                    code:'51',
                     parentName:'广东',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  {
                    name: '韶关市',
                    code:'51',
                     parentName:'广东',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  {
                    name: '河源市',
                    code:'51',
                     parentName:'广东',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  {
                    name: '清远市',
                    code:'51',
                     parentName:'广东',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  {
                    name: '云浮市',
                    code:'51',
                     parentName:'广东',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  {
                    name: '荔湾区',
                    code:'51',
                     parentName:'广东',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  {
                    name: '越秀区',
                    code:'51',
                     parentName:'广东',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  {
                    name: '海珠区',
                    code:'51',
                     parentName:'广东',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  {
                    name: '天河区',
                    code:'51',
                     parentName:'广东',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  {
                    name: '白云区',
                    code:'51',
                     parentName:'广东',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  {
                    name: '番禺区',
                    code:'51',
                     parentName:'广东',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  {
                    name: '花都区',
                    code:'51',
                     parentName:'广东',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  {
                    name: '南沙区',
                    code:'51',
                     parentName:'广东',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  {
                    name: '从化区',
                    code:'51',
                     parentName:'广东',
                    label: { color: '#fff' },
                    itemStyle: { areaColor: '#FFD654' }
                  },
                  ]
                }else{
                  data = value.data;
                  let obj = statusCity.statusCity;
                  if(obj[`${provinceName}`]){
                    this.mapOption.series[0].data = obj[`${provinceName}`].seriesData;
                   let regions = [];
                   for(let i=0;i<obj[`${provinceName}`].regions.length;i++){
                    regions.push({
                      name: obj[`${provinceName}`].regions[i].name,
                      label: { color: obj[`${provinceName}`].regions[i].fontColor,distance:50 },
                      itemStyle: { areaColor: obj[`${provinceName}`].regions[i].BgColor },
                      parentName:provinceName,
                      code:obj[`${provinceName}`].regions[i].code
                    })
                   }
                   this.mapOption.geo.regions = regions;
                  }else{
                    this.mapOption.series[0].data = [];
                    this.mapOption.geo.regions = [];
                  }
                }

                this.mapOption.geo.map = 'Pmap';
                this.$echarts.registerMap('Pmap', data);
                this.mapChart.setOption(this.mapOption);
                this.isreturn = true;
              }
            });

          })
          this.mapChart.on('georoam', params => {
             //posHandler.reset();
             this.mapChart.resize();
          })
        },
        rebackMap() { //返回全国地图
          this.mapChart.clear();
          this.mapOption.geo.regions = this.regions;//设置显示的海关
          this.mapOption.series[0].data = this.seriesData;
          this.mapOption.geo.map = 'china';
          this.mapChart.setOption(this.mapOption);
          this.isreturn = false;
          this.statusCode = '';
          this.dataInfo();
        },
        requestFullScreen () {
          let de = document.documentElement
          if (de.requestFullscreen) {
            de.requestFullscreen()
          } else if (de.mozRequestFullScreen) {
            de.mozRequestFullScreen()
          } else if (de.webkitRequestFullScreen) {
            de.webkitRequestFullScreen()
          }
        },
        exitFullscreen () {
          let de = document
          if (de.exitFullscreen) {
            de.exitFullscreen()
          } else if (de.mozCancelFullScreen) {
            de.mozCancelFullScreen()
          } else if (de.webkitCancelFullScreen) {
            de.webkitCancelFullScreen()
          }
        },
        toFullOrExit () {
          this.isFull = !this.isFull
          if (this.isFull) {
            this.fullImg = require('../../static/quxiaoquanping_o.png')
            this.requestFullScreen()
          } else {
            this.fullImg = require('../../static/quanping_o.png')
            this.exitFullscreen()
          }
        }


      }
}

</script>

<style>
  @font-face {
      font-family: "DIN_Condensed_Bold";
      src: url("../../static/DIN_Condensed_Bold.ttf");
  }

  .totals{
    font-size: 18px;
    text-align: center;
    padding-bottom: 5px;
  }

  .main{
    position: relative;
  }
  .topBtn{
    position: absolute;
    top:10px;
    width: 100%;
    padding:0 15px;
    display: flex;
    justify-content: space-between;
  }
  .full-screen img{
    width: 50px;
    height: 50px;
    cursor: pointer;
  }
  #index-box{
    background: url(../../static/bg3.jpg);
    background-size: cover!important;
  }
  .loading{
    background: url(../../static/bg3.jpg);
    background-size: cover!important;
    color:#fff;
  }
  .main-body{
    background: url(../../static/bg3.jpg);
    background-size: cover!important;
    width: 100%;
    height: 100%;
  }
  .totalItem{
    width: 250px;
    height: 100px;
    background: inherit;
    background-color: rgba(49, 167, 255, 0.298039215686275);
    box-sizing: border-box;
    border-width: 4px;
    border-style: solid;
    border-color: rgba(49, 167, 255, 1);
    border-top: 0px;
    border-right: 0px;
    border-bottom: 0px;
    border-radius: 0px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-family: '微软雅黑';
    font-weight: 400;
    font-style: normal;
    color: #FFFFFF;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .totalItem .icon{
    margin-right:15px;
  }
  .totalItem .numberText{
    font-size: 16px;
    font-family: '微软雅黑';
    font-weight: 400;
  }
  .totalItem .number{
    font-size: 36px;
    font-family: 'DIN_Condensed_Bold';
    font-weight: 700;
    padding-top:6px;
  }
  .height33{
    height: 30%;
  }
  .top-header{
        position: relative;
        width: 100%;
        height: 80px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        -ms-flex-negative: 0;
        flex-shrink: 0;

  }
  .top-header .center-title {
      position: absolute;
      font-size: 42px;
      font-weight: 700;
      left: 50%;
      top: 15px;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
      color:#fff;
  }
  .map{
    height: 100%;
  }
  .mapName{
    color:#fff;
    font-size:18px;
    font-weight:bold;
  }
  .tips{
    position:absolute;
    bottom:30px;
    left:30px;
    color:red;
  }
   .tips span{
     border:1px solid red;
     padding:10px 15px;
     margin-right:10px;
   }
  .search{
    display:flex;
    align-items: left;

    margin-top:20px;
    margin-bottom:20px;
  }
  .search span{
    background-color: rgba(49, 167, 255, 0.298039215686275);
    color:#fff;
    padding:10px 20px;
    border-radius:5px;
    margin-right:8px;
    cursor:pointer;

  }
  .search span.active{
    background-color: rgba(49, 167, 255, .8);
    color:#fff;
  }
  .tableBox{
    display:flex;
    padding:10px 30px;
  }
  .leftTable,.rightTable{
    flex:1
  }
  .box1 {
      width: 610px;
      height: 310px;
  }
  .box{
 /* background-color: rgba(49, 167, 255, 0.2); */
   background-color: rgba(57, 161, 251, 0.1);
    /* border-top: 2px solid rgba(1,153,209,.5); */
    color:#fff;
    text-align: left;
    padding:10px 15px 0 15px;
    margin-bottom: 10px;
  }
  .boxbg{
    color:#fff;
    text-align: left;
    padding:10px 15px 0 15px;
    margin-bottom: 10px;
    position:relative;
  }
  .boxTitle{
    border-left:6px solid #00ADEF;
    font-size: 24px;
    font-weight: bold;
    display: inline-block;
    padding:2px 15px;
  }
  .boxTitle1{
    border-left:6px solid #00ADEF;
    font-size: 18px;
    font-weight: bold;
    display: inline-block;
    padding:2px 15px;
  }
  .boxTitleTips{
    font-size: 22px;
    padding:30px 0;
    text-align: center;
  }
.index{
  display:flex;
  padding:5px 30px;
  width:100%;
  box-sizing: border-box;
  height: calc(100% - 80px);
}
.left{
  /* width:31%; */
  width:16%;
  margin-right:-6%;
  display: flex;
  z-index: 1000;
}
.center{
  /* width:50%; */
  width:65%;
  position:relative;
 /* overflow: hidden; */
/*  min-width: 1000px; */
}
.right{
  width:31%;
  color:#fff;
  margin-left:-6%;
}
.returnBox{
  display: flex;
  justify-content: space-between;
  padding: 0 350px;
}
.return{
  font-size: 23px;
  z-index:99999999;
  color:#fff;
  cursor:pointer;
  padding:15px;
}
.total{
  display:flex;
  justify-content:space-between;
  position: absolute;
  top:60px;
  padding: 0 20px;
  z-index: 99999999;
  width:900px;
  left:50%;
  margin-left: -500px;
}
.number{
  display:flex;
  align-items:center;
  font-size:26px;
  color:#fff;
}
.number span{
  font-size:28px;
  font-weight:bold;
  display:flex;
  align-items:center;
  justify-content:center;
  color:#fff;
}
 select{
    background-color: rgba(57, 161, 251, 0.1);
    border:1px solid rgba(57, 161, 251, 0.1);
    color:#0CB2E0;
    width:80px;
    height:30px;
  /*  margin-top:10px; */
    margin-right:10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/index.vue